import React, {
  Component
} from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Modal from "../Modal";
import * as modal from "../../reducers/modalReducer";
import RaisedButton from "material-ui/RaisedButton";
import styled from "styled-components";
import {
  BODY_TEXT_COLOR,
  NEGATIVE_COLOR,
  LIGHT_GREY
} from "../../config/colors";
import {
  HeaderDiv,
  TextDiv
} from "../../modals";
import { SelectField, MenuItem } from "material-ui";
import { CloseIcon } from "../../icons";

const styles = {
  button: { width: 150, fontWeight: 700 },
  secondaryButtonColor: NEGATIVE_COLOR,
  labelStyle: { fontWeight: 700 },
  closeIconWrap: { position: 'absolute', right: 10, top: 10, cursor: 'pointer', zIndex: 10 },
  closeIcon: { height: '35px', width: '35px', color: LIGHT_GREY },
  selectInput: { padding: 0, fontSize: 13, width: 360 }
};

class ChooseBankAccountModal extends Component {
  modalStyle = { border: `3px solid #${this.props.secondaryColor}`, maxWidth: '600px' };
  secondaryColor = ["#", this.props.secondaryColor].join("");

  constructor(props) {
    super(props);

    this.state = {
      selectedPaymentSourceId: null
    }
  }

  onCloseRequest = () => {
    if (this.state.handleNegativeClick) return;
    this.props.hideModal();
  };

  handleChange = (event, index, value) => {
    this.setState({ selectedPaymentSourceId: value });
  }

  submit = () => {
    const { selectedPaymentSourceId } = this.state;

    this.props.hideModal();
    this.props.onSubmit(selectedPaymentSourceId);
  }

  render() {
    const {
      paymentSources
    } = this.props;
    
    const menuItems = paymentSources.map((source, idx) => <MenuItem key={idx} value={source.id} primaryText={source.label} />);

    return (
      <Modal
        style={this.modalStyle}
        overlayTop={0}
        closeOnOutsideClick={true}
        isOpened={true}
        onClose={this.onCloseRequest}
      >
        <div onClick={this.onCloseRequest} style={styles.closeIconWrap}><CloseIcon style={styles.closeIcon} /></div>

        <ModalWrapperDiv>
          <HeaderDiv>Choose the Bank Account</HeaderDiv>

          <div style={{  }}>
            <SelectField
              floatingLabelText="Select bank account"
              style={styles.selectInput}
              value={this.state.selectedPaymentSourceId}
              onChange={this.handleChange}
            >
              {menuItems}
            </SelectField>

          </div>

          <ButtonsWrapperDiv>
            <RaisedButton
              onClick={this.submit}
              backgroundColor={this.secondaryColor}
              labelColor="#FFF"
              labelStyle={styles.labelStyle}
              label="PAY NOW"
              disabled={!this.state.selectedPaymentSourceId}
              style={styles.button}
            />
          </ButtonsWrapperDiv>
        </ModalWrapperDiv>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    secondaryColor: state.config.secondaryColor
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideModal: () => dispatch(modal.hideModal())
  };
};

ChooseBankAccountModal.propTypes = {
  paymentSources: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseBankAccountModal);

const ModalWrapperDiv = styled.div`
  display: flex;
  color: ${BODY_TEXT_COLOR};
  flex-direction: column;
  font-size: 18px;
  align-items: center;
  justify-content: center;
  margin: 20px auto 20px;
  height: 100%;
  padding: 0 35px;
  @media (max-width: 768px) {
    padding: 0 25px;
  }
`;

const ButtonsWrapperDiv = styled.div`
  display: flex;
  justify-content: space-around;
  width: 366px;
  @media (max-width: 768px) {
    width: 355px;
    align-items: center;
    & > div {
      margin-bottom: 5px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ChooseBankAccountModal/ChooseBankAccountModal.jsx